document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.faq-tabs-section .tab')
    const contents = document.querySelectorAll('.faq-tabs-section .tab-content')
    // Dropdown control
    const select = document.querySelector('#faq-tabs-select')
    if (select) {
        select.addEventListener('change', (e) => {
            const selectedTab = e.target.value

            tabs.forEach(t => {
                t.classList.remove('active')
                if (t.dataset.tab === selectedTab) t.classList.add('active')
            })

            contents.forEach(c => {
                c.classList.remove('active')
                if (c.dataset.content === selectedTab) c.classList.add('active')
            })
        })
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'))
            contents.forEach(c => c.classList.remove('active'))

            tab.classList.add('active')
            document.querySelector(`.tab-content[data-content="${tab.dataset.tab}"]`).classList.add('active')
        })
    })

    document.querySelectorAll('.accordion-question').forEach(button => {
        button.addEventListener('click', () => {
            const item = button.parentElement
            item.classList.toggle('active')
        })
    })
})